import React from "react";
import ButtonGroup from "./ButtonGroup";
import Grid from "@mui/material/Grid";

/**
 * A component that lists a list of buttons on the left and the last on the right
 * An example might be new button on the left and search button on the right
 * Notes:
 * 1. Expecting atleast 2 buttons as children
 * 2. Assuming that this component is part of a larger grid
 */
export default function ButtonBar({ children }) {
  return (
    <Grid
      item
      xs={12}
      display="flex"
      justifyContent="space-around"
      columnGap="10px"
    >
      <ButtonGroup>{children.slice(0, -1)}</ButtonGroup>
      {children[children.length - 1]}
    </Grid>
  );
}
